import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Injector,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { UntypedFormArray, UntypedFormGroup, Validators } from '@angular/forms';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { ReferenceDao } from '@app/dao/reference/reference.dao';
import { Subject, Subscription, combineLatest, takeUntil } from 'rxjs';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'tax-residency-form',
    templateUrl: './tax-residency-form.component.html',
    styleUrls: ['./tax-residency-form.component.scss'],
    standalone: false
})
export class TaxResidencyFormComponent
  extends EaSubscriptionBuilder
  implements OnInit, AfterViewInit, OnDestroy
{
  countries: any[];
  departments: any[];
  private destroy$ = new Subject<void>();
  private valueChangeSubscription: Subscription | undefined;

  constructor(
    protected formConstructor: PrFormConstructor,
    private referenceDao: ReferenceDao,

    private subscriptionFacade: SubscriptionFacadeService,
    private cdr: ChangeDetectorRef,
    protected injector: Injector,
  ) {
    super(formConstructor, injector);
  }
  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  ngOnInit() {
    combineLatest([this.referenceDao.getCountries()])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([countries]) => {
        this.countries = countries;
        this.subscriptionFacade.initForm(this);
      });
    this.subscriptionFacade.initForm(this);

    this.valueChangeSubscription = this.owners
      ?.get(`${0}`)
      ?.get('isTrue')
      .valueChanges.pipe(untilDestroyed(this))
      .subscribe(value => {
        if (!value) {
          this.clearOtherNifControls();
        }
      });
  }
  private clearOtherNifControls() {
    (<UntypedFormArray>this.owners?.get(`${0}`)?.get('otherNif')).clear();
  }
  clearValidation() {
    const otherNifControls = (<UntypedFormArray>(
      this.owners?.get(`${0}`)?.get('otherNif')
    )).controls;
    otherNifControls.forEach((control: UntypedFormGroup) => {
      const nifControl = control.controls.nif;
      const countryControl = control.controls.country;
      nifControl.clearValidators();
      countryControl.clearValidators();
      countryControl.updateValueAndValidity();
      nifControl.updateValueAndValidity();
    });
  }
  setValidations() {
    const otherNifControls = (<UntypedFormArray>(
      this.owners?.get(`${0}`)?.get('otherNif')
    )).controls;
    otherNifControls.forEach((control: UntypedFormGroup) => {
      const nifControl = control.controls.nif;
      const countryControl = control.controls.country;
      nifControl.setValidators(Validators.required);
      countryControl.setValidators(Validators.required);

      nifControl.updateValueAndValidity();
      countryControl.updateValueAndValidity();
    });
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();

    if (this.valueChangeSubscription) {
      this.valueChangeSubscription.unsubscribe();
    }
  }
}
